export interface AuditModel {
    logs: string[];
  }
  
  const auditModel: AuditModel = {
    logs: []
  };
  
  export default auditModel;
  